import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { PrismicRichText, PrismicLink } from '@prismicio/react'

const Card = ({ fields }) => {
  return (
    <li className='component-card relative flex flex-1 flex-col '>
      {fields.image.gatsbyImageData && (
        <div className='transform overflow-hidden rounded-lg shadow-md transition duration-500'>
          <GatsbyImage image={fields.image.gatsbyImageData} alt={fields.image.alt || ''} />
        </div>
      )}
      <div className={`group z-10 flex flex-grow flex-col rounded-lg bg-white p-6 shadow-md ${fields.image.gatsbyImageData && `mx-3 -mt-10`}`}>
        <div className='prose mb-3 uppercase tracking-wider text-primary'>
          <PrismicRichText field={fields.title.richText} />
        </div>
        <div className='text-bluegray-500 prose prose-lg mb-6 leading-snug'>
          <PrismicRichText field={fields.text.richText} />
        </div>
        {fields.button_link?.url && (
          <div className='mt-auto flex'>
            <PrismicLink className='button-brand button rounded-lg' href={fields.button_link.url}>
              {fields.button_text}
            </PrismicLink>
          </div>
        )}
      </div>
    </li>
  )
}

export default Card
